"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.outboundWebhookEventDto = exports.payrollToOutboundWbStatusMap = exports.outboundWbToPayrollStatusMap = exports.OutboundWebhookStatus = void 0;
const zod_1 = require("zod");
const payroll_1 = require("../../payroll");
var OutboundWebhookStatus;
(function (OutboundWebhookStatus) {
    OutboundWebhookStatus["SENT"] = "sent";
    OutboundWebhookStatus["PENDING"] = "pending";
    OutboundWebhookStatus["FAILED"] = "failed";
})(OutboundWebhookStatus = exports.OutboundWebhookStatus || (exports.OutboundWebhookStatus = {}));
exports.outboundWbToPayrollStatusMap = new Map([
    [OutboundWebhookStatus.PENDING, payroll_1.PayrollHookEventsStatus.PENDING],
    [OutboundWebhookStatus.SENT, payroll_1.PayrollHookEventsStatus.FINISHED],
    [OutboundWebhookStatus.FAILED, payroll_1.PayrollHookEventsStatus.FAILED],
]);
exports.payrollToOutboundWbStatusMap = new Map([...exports.outboundWbToPayrollStatusMap].map(([key, value]) => [value, key]));
exports.outboundWebhookEventDto = zod_1.z.object({
    id: zod_1.z.string().min(1),
    new_status: zod_1.z.nativeEnum(OutboundWebhookStatus),
    old_status: zod_1.z.nativeEnum(OutboundWebhookStatus),
});
__exportStar(require("./auth"), exports);
__exportStar(require("./template"), exports);
__exportStar(require("./requests"), exports);
__exportStar(require("./events"), exports);
